import { formatDate } from "@offstreetparking/design-system/formatters";
import type { PaymentScheduleSummary } from "@offstreetparking/domain/value/payment-schedule";

export type SummaryProps = {
	overview: PaymentScheduleSummary;
	locale: string;
	currency: string;
};

// The summary reports deduction dates as UTC calendar dates, so they are pinned to a UTC instant
// rather than left for the viewer's own timezone to reinterpret.
export const formatDeductionDate = ({ date, locale }: { date: string; locale: string }) =>
	formatDate({
		date: new Date(`${date}T00:00:00.000Z`),
		formatType: "Abbreviated_Date",
		timezone: "UTC",
		language: locale,
	});
